// extracted by mini-css-extract-plugin
export default {"containerSpinner":"containerSpinner__N4ocr","spinner":"spinner__12bKu"};